import { useQuery } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type EhrCredentialsV2Data = {
  client_id?: string;
  client_secret?: string;
  practice_id?: string;
  api_version?: number;
  [key: string]: unknown;
};

export type GetEhrCredentialsV2Response = {
  success: boolean;
  code: number;
  message?: string;
  data: EhrCredentialsV2Data | null;
};

export type UseGetEhrCredentialsV2Params = {
  org_uuid: string;
  ehr_system: string;
};

export const useGetEhrCredentialsV2 = (
  params: UseGetEhrCredentialsV2Params,
  options: UseQueryOverrideOptions = {}
) => {
  const { org_uuid, ehr_system } = params;
  return useQuery({
    queryKey: ['ehrCredentialsV2', params],
    queryFn: () =>
      integrationsApi
        .get<GetEhrCredentialsV2Response>('/v2/ehr/credentials', {
          params: { org_uuid, ehr_system },
        })
        .then((res) => res.data),
    enabled: Boolean(org_uuid && ehr_system),
    refetchOnWindowFocus: false,
    ...options,
  });
};
